import React, { useEffect, useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";
import { getToken } from "../token";
import { FORUM } from "../Theme/styles";
import TaskModal from "../Components/TaskModal";
import { MY_TASKS_PATH } from "../categories";

const TaskLink = () => {
  const { taskId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const zamknij = () => {
    if (location.key !== "default") {
      navigate(-1);
      return;
    }
    navigate(MY_TASKS_PATH);
  };
  const [people, setPeople] = useState([]);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${getToken()}` };
    axios
      .get(`${API_URL}/users`, { withCredentials: true, headers })
      .then((r) => setPeople(r.data || []))
      .catch(() => setPeople([]));
    axios
      .get(`${API_URL}/tasks/${taskId}`, { withCredentials: true, headers })
      .catch(() => setMissing(true));
  }, [taskId]);

  if (missing) {
    return (
      <Flex direction={"column"} gap={2} p={4}>
        <Text fontSize={"lg"} color={FORUM.tekstJasny}>
          Nie ma takiego zadania
        </Text>
        <Text fontSize={"sm"} color={FORUM.tekstPrzygaszony}>
          Mogło zostać usunięte albo link jest niepełny.
        </Text>
      </Flex>
    );
  }

  return (
    <TaskModal
      isOpen
      onClose={zamknij}
      taskId={taskId}
      peoples={people}
    />
  );
};

export default TaskLink;
